import { useEffect, useState } from 'react';
import { VatTypes } from '../library/constants/dynamic.js';

export const usePurchasebillLineTotals = (initialTotalPriceExclVat, initialVisibleVatId, initialGeneralLedgerId, recomputedVat) => {
    const [totalPriceExclVat, setTotalPriceExclVat] = useState(parseFloat(initialTotalPriceExclVat) || 0.00);
    const [visibleVatId, setVisibleVatIdState] = useState(initialVisibleVatId);
    const [generalLedgerId, setGeneralLedgerId] = useState(initialGeneralLedgerId);
    const [totalPriceInclVat, setTotalPriceInclVat] = useState(0.00);

    const visibleVat = VatTypes.find(({ id }) => Number(id) === Number(visibleVatId))?.percentage / 100

    useEffect(() => {
        const totalInclVat = parseFloat(totalPriceExclVat) * (1 + parseFloat(visibleVat));
        setTotalPriceInclVat(isNaN(totalInclVat) ? null : totalInclVat);
    }, [totalPriceExclVat, visibleVatId]);

    // Manual VAT change: updates VAT rate and price incl. VAT only.
    // General Ledger is independent of VAT selection.
    const setVisibleVatId = (vatTypeId) => {
        setVisibleVatIdState(vatTypeId);
    };

    // Entity changed: apply the server's authoritative recompute
    // (via the vat-preview endpoint).
    useEffect(() => {
        if (recomputedVat === undefined) return;
        setVisibleVatIdState(recomputedVat?.vat_type_id ?? null);
        setGeneralLedgerId(recomputedVat?.general_ledger_id ?? null);
    }, [recomputedVat]);

    return {
        totalPriceExclVat,
        setTotalPriceExclVat: (val) => setTotalPriceExclVat(parseFloat(val) || 0),
        visibleVatId,
        setVisibleVatId,
        totalPriceInclVat,
        generalLedgerId,
        setGeneralLedgerId,
    };
}

